import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './analiticaImportacaoMesForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, 
	getLista, getListaUnidade
} from './analiticaImportacaoMesActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import consts from '../consts';
import Aguardando from '../common/template/aguardando';

class AnaliticaImportacaoMes extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaUnidade();
	}
	
	componentWillUnmount() {
	
	}

    render() {
        return (
            <div>
				
				<Aguardando aguardando={this.props.aguardando} />

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const listaCompetencias = [
			...new Set(this.props.lista.map(item => item.competencia))
		].map(competencia => ({
			id: competencia,
			valor: FormatUtils.formatarCompetenciaTela(competencia)
		}));

		listaCompetencias.sort((a, b) => a.id > b.id ? -1 : 1);

		let valorTotal = 0;

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 12 2 2'
							placeholder='Selecione'
							value={this.state.id_unidade}
							onChange={value => {
								this.setState({
									id_unidade: value
								});
							}} />


						<Select
							options={this.props.listaTipo}
							label='Tipo'
							cols='12 12 4 3'
							placeholder='Selecione'
							value={this.state.tipo}
							onChange={value => {
								this.setState({
									tipo: value
								});
							}} />
						
						<Select
							options={listaCompetencias}
							label='Competência'
							cols='12 12 2 2'
							placeholder='Selecione'
							value={this.state.competencia}
							onChange={value => {
								this.setState({
									competencia: value
								});
							}} />


						<Grid cols='6 6 2 1' style={{ paddingTop: 29, minWidth: 120 }}>
							<Button
								text='Importar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Unidade</Th>
								<Th alignCenter>Competência</Th>
								<Th alignCenter>Tipo</Th>
								<Th alignCenter>Nome</Th>
								<Th alignRight>Valor</Th>
								<Th alignRight>Data/Hora Importação</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => {
								if (this.state.pesquisar
									&& !(`
										${item.nome_unidade}
										${FormatUtils.formatarCompetenciaTela(item.competencia)}
										${item.tipo}
										${item.nome_tipo}
										${FormatUtils.formatarValorTelaDecimal(item.valor, 2)}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								} else if (this.state.id_unidade && this.state.id_unidade != item.id_unidade) {
									return false;
								} else if (this.state.tipo && this.state.tipo.toUpperCase() != item.tipo.toUpperCase()) {
									return false;
								} else if (this.state.competencia && this.state.competencia != item.competencia) {
									return false;
								}

								return true;
							}).map(item => {

								valorTotal += parseFloat(item.valor || 0);
								
								return (
									<Tr key={`${item.tipo}-${item.id}`} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td alignCenter>{item.nome_unidade}</Td>
										<Td alignCenter>{FormatUtils.formatarCompetenciaTela(item.competencia)}</Td>
										<Td alignCenter>{item.tipo}</Td>
										<Td alignCenter>{item.nome_tipo}</Td>
										<Td alignRight>{FormatUtils.formatarValorTelaDecimal(item.valor, 2)}</Td>
										<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_alteracao)}</Td>
									</Tr>
								);
							})}
							<Tr>
								<Td alignCenter bold>Total</Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignCenter></Td>
								<Td alignRight bold>{FormatUtils.formatarValorTelaDecimal(valorTotal, 2)}</Td>
								<Td alignCenter></Td>
							</Tr>
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.analiticaImportacaoMes,
	aguardando: state.analiticaImportacaoMes.aguardando,
	modoTela: state.analiticaImportacaoMes.modoTela,
	lista: state.analiticaImportacaoMes.lista,
	listaUnidade: state.analiticaImportacaoMes.listaUnidade,
	listaTipo: state.analiticaImportacaoMes.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, 
	getLista, getListaUnidade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AnaliticaImportacaoMes);
